import { render, staticRenderFns } from "./BannerSlider.vue?vue&type=template&id=3950303d&scoped=true"
import script from "./BannerSlider.vue?vue&type=script&lang=js"
export * from "./BannerSlider.vue?vue&type=script&lang=js"
import style0 from "./BannerSlider.vue?vue&type=style&index=0&id=3950303d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3950303d",
  null
  
)

export default component.exports